import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'

import { ContactForm, ContactResponse } from '../types/contact'

export const emptyContact: ContactForm = {
  bio: '',
  birthdate: null,
  city: '',
  country: '',
  einSsn: '',
  email: '',
  entityName: '',
  firstName: '',
  id: 0,
  lastName: '',
  mobilePhone: '',
  phone: '',
  state: '',
  street: '',
  zipCode: ''
}

const request = (id: number | undefined) =>
  id ? Request.getVirtual(Request.urls.bank.contactEditWebPage, { id }) : Promise.resolve(emptyContact)

export const useContactItem = (id: number) =>
  useQuery<ContactResponse, Error>({
    queryFn: () => request(id),
    queryKey: ['contact-edit', id],
    placeholderData: keepPreviousData
  })
